// removed by extract-text-webpack-plugin
module.exports = {"validation-error":"input-field__validation-error___2oWSR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/input-field/input-field.scss
 ** module id = 1302
 ** module chunks = 1
 **/